import LocalStorageService from '../services/LocalStorageService'
import { LOCAL_STORAGE_KEYS } from './storage'
import { isNotNilOrEmpty } from './ramda'
import * as R from 'ramda'
import { noTimezoneDate, removeUTCFromDate } from './date'
import { Course } from 'types/courses'
import { differenceInDays } from 'date-fns'
import { EK_BASE_URL } from 'utils/url'

export const EXTEND_SUBSCRIPTION_URL = `${EK_BASE_URL}my-account?panel=orders`

export const COURSE_LEARNING_TIME_STATUS = {
  started: 'started',
  paused: 'paused'
}

export const COURSE_TYPES = {
  live: 'live_course',
  onDemand: 'on_demand',
  freeTrial: 'free_trial'
}

export const DAYS_TO_PROMPT_SUBSCRIPTION = 17

export const saveCourseStorageKeys = async course => {
  await LocalStorageService.set(LOCAL_STORAGE_KEYS.studentCourseId, course.id)

  await LocalStorageService.set(
    LOCAL_STORAGE_KEYS.originalCourseId,
    course.book_course_id
  )

  await LocalStorageService.set(LOCAL_STORAGE_KEYS.studentCourseId, course.id)

  await LocalStorageService.set(
    LOCAL_STORAGE_KEYS.studentCourseType,
    course.type
  )

  if (isNotNilOrEmpty(course.end_date_id)) {
    await LocalStorageService.set(
      LOCAL_STORAGE_KEYS.studentCourseEndDateId,
      course.end_date_id
    )
  }
}

export const removeCourseStorageKeys = () => {
  LocalStorageService.remove(LOCAL_STORAGE_KEYS.studentCourseId)
  LocalStorageService.remove(LOCAL_STORAGE_KEYS.studentCourseType)
  LocalStorageService.remove(LOCAL_STORAGE_KEYS.studentCourseEndDateId)
  LocalStorageService.remove(LOCAL_STORAGE_KEYS.originalCourseId)
}

export const getCourseRemainingDays = (course: Course) => {
  const endDateUTC = R.propOr('0000-00-00T00:00:00Z', 'accessible_to', course)

  const now = new Date()
  // @ts-ignore
  const endDate = noTimezoneDate(removeUTCFromDate(endDateUTC))

  // @ts-ignore
  return differenceInDays(endDate, now)
}

export const getCourseStudyDays = (course: Course) => {
  const endDateUTC = R.propOr('0000-00-00T00:00:00Z', 'accessible_to', course)
  const startDateUTC = R.propOr(
    '0000-00-00T00:00:00Z',
    'calendar_start_at',
    course
  )

  // @ts-ignore
  const startDate = noTimezoneDate(removeUTCFromDate(startDateUTC))
  // @ts-ignore
  const endDate = noTimezoneDate(removeUTCFromDate(endDateUTC))

  // @ts-ignore
  return differenceInDays(endDate, startDate)
}
